class TagCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.color = options?.color ? false
        @.disabled = options?.disabled ? false
        @.iconBlack = options?.iconBlack ? false
        @.id = options?.id ? false
        @.link = options?.link ? false
        @.tag = if @.link then 'a' else (options?.tag ? 'button')
        @.text = options?.text ? 'n/a'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'tag'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.tag == 'button'
            @.$el.type = 'button'
            if @.disabled
                @.$el.disabled = true
        else
            if @.disabled
                @.$el.classList.add 'tag--disabled'
        if @.tag == 'a' && @.link
            @.$el.href = @.link
        if @.color
            @.$el.classList.add ('tag--' + @.color)
        if @.iconBlack
            @.$el.classList.add 'tag--icon-black'
        @.$el.innerHTML = "
            <span class='tag__icon'></span>
            <span class='tag__text'>#{ @.text }</span>
        "
        return

window.CreateTag = (options) ->
    return new TagCreate options